import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import SellUsedLuxuryCars from "./component";
import { setData, setStep } from "../lead-form/actions";
import { fetchLuxuryPageData } from "./actions";
import { updateLeadSource } from "../../../components/desktop/settings/actions";

const mapStateToProps = ({
    luxuryCars: { cmsData, isSSR }
}) => {
    return {
        isSSR,
        cmsData
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setDataConnect: setData,
    setStepConnect: setStep,
    fetchLuxuryPageDataConnect: fetchLuxuryPageData,
    updateLeadSourceConnect: updateLeadSource
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SellUsedLuxuryCars));
